import { render, staticRenderFns } from "./printRemoteCall.vue?vue&type=template&id=0f83fe72"
import script from "./printRemoteCall.vue?vue&type=script&lang=js"
export * from "./printRemoteCall.vue?vue&type=script&lang=js"
import style0 from "./printRemoteCall.vue?vue&type=style&index=0&id=0f83fe72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports